export function getCurrencySymbol(currency: string) {
  return new Intl.NumberFormat(new Intl.NumberFormat().resolvedOptions().locale, {
    style: 'currency',
    currency: currency,
    currencyDisplay: 'symbol',
  })
    .formatToParts(1)
    .find((part) => part.type === 'currency')?.value;
}
